import { useParams } from "react-router-dom";
import { Box } from "@mui/material";

import { useGroupsListQuery } from "../../../../../Groups/api/queries/useGroupsListQuery";
import { Group } from "../../../../../Groups/api/types/group.types";

import { CreateNewGroupCard, GroupCard, GroupCardSkeleton } from "./GroupCard";
import NoGroups from "./NoGroups";

const GroupsTab = () => {
  const { entityId } = useParams();
  const { data: groups, isLoading } = useGroupsListQuery(Number(entityId));

  if (isLoading || !groups)
    return (
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
          gap: "16px",
          width: "100%",
          minWidth: 0,
        }}
      >
        {[...Array(3)].map((_, index) => (
          <GroupCardSkeleton key={index} />
        ))}
      </Box>
    );

  if (groups.length === 0) return <NoGroups />;

  return <GroupsList groups={groups} />;
};

export default GroupsTab;

const GroupsList = ({ groups }: { groups: Group[] }) => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
        gap: "16px",
        width: "100%",
        minWidth: 0,
      }}
    >
      <CreateNewGroupCard />
      {groups.map((group) => (
        <GroupCard key={group.id} group={group} />
      ))}
    </Box>
  );
};
